import React from 'react';
import WelcomeImage from 'fitbeat.react-native-components/assets/images/welcome-background.web.png';
import { AuthTitleBar } from './AuthTitleBar';

export const BaseAuthLayout = (props) => (
    <div className='auth-container full-per' style={{ backgroundColor: props.backgroundColor ? props.backgroundColor : 'none'}}>
        <AuthTitleBar header={props.header} />
        <div className='grid-x align-center content-top-padding full-per'>
            <div className='cell small-12 medium-6 large-5 align-self-top padding-top-3 hide-for-small-only'>
                <div className='header-container'>
                    <h1>{props.header}</h1>
                </div>
                <img src={WelcomeImage} />
            </div>
            <div className='cell small-12 medium-6 large-4 align-self-top padding-3 full-per scroll' id='right-content'>
                {props.children}
            </div>
        </div>
    </div>
);
